import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=5be230fa&scoped=true"
import script from "./Device.vue?vue&type=script&lang=js"
export * from "./Device.vue?vue&type=script&lang=js"
import style0 from "./Device.vue?vue&type=style&index=0&id=5be230fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be230fa",
  null
  
)

export default component.exports